var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.properties),function(prop,index){return _c('v-chip',{key:index,attrs:{"label":prop.label,"dark":prop.dark,"color":prop.color}},[_vm._v("\n    "+_vm._s(prop.dataText)+"\n    "),_c('v-icon',[_vm._v(" "+_vm._s(prop.icon)+" ")])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }